import { CustomerLead } from '../../../core/domain/customerLead.model'
import { OfferData } from '../../../core/domain/offerData.model'
import { OfferDocumentDTO } from '../../../core/domain/offerDocument.dto'
import { PolicyViewModel } from './Policy.model'

export const policyViewMapper = (
  offer: OfferData,
  document: OfferDocumentDTO,
  customer: CustomerLead,
) => {
  const policy: PolicyViewModel = {
    vehicles: offer.vehiclesToEnsure,
    plate1: offer.plate1,
    plate2: offer.plate2,
    plate3: offer.plate3,
    plate4: offer.plate4,
    plate5: offer.plate5,
    globalInsured: offer.globalInsured,
    insuredVehicle1: offer.insuredVehicle1,
    insuredVehicle2: offer.insuredVehicle2,
    insuredVehicle3: offer.insuredVehicle3,
    insuredVehicle4: offer.insuredVehicle4,
    insuredVehicle5: offer.insuredVehicle5,
    deductible: offer.deductible,
    transCH: offer.transCH,
    transEurope: offer.transEurope,
    transRemoval: offer.transRemoval,
    transTheft: offer.transTheft,
    liability: offer.liability,
    company: customer.company,
    firstName: customer.firstName,
    lastName: customer.lastName,
    email: customer.email,
    phone: customer.phone,
    country: customer.country,
    city: customer.city,
    postalAddress: customer.postalAddress,
    postalAddressOpt: customer.postalAddressOpt,
    postalCode: customer.postalCode,

    reqContact: customer.reqContact,
    acceptedPrivacyPolicy: customer.acceptedPrivacyPolicy,
    informedTermsAndConditions: customer.informedTermsAndConditions,

    price: document.price,
    pricingDate: document.pricingDate,
    creationDate: document.creationDate,
    contractingDate: document.contractingDate,
    validityStartDate: document.validityStartDate,
    validityInYears: document.validityInYears,
  }
  return policy
}
